export var GET_NEWS = 'GET_NEWS';
export var SUCCESS_GET_NEWS = 'SUCCESS_GET_NEWS';
export var FAILURE_GET_NEWS = 'FAILURE_GET_NEWS';



// WEBPACK FOOTER //
// ./src/actions/news.js